import { mainBackendApi } from '@/services'
import type { NetworkCurrency } from '@/models/NetworkCurrency'

export const NetworkCurrencyService = mainBackendApi.injectEndpoints({
	endpoints: build => ({
		getNetworkCurrencies: build.query<NetworkCurrency[], void>({
			query: () => ({
				url: '/client/network-currency/',
				method: 'GET',
			}),
			providesTags: ['NetworkCurrency'],
		}),
	}),
})
